/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AdminSchedulingLinkId,
  AvailabilityFeature,
  CheckUsersAvailabilityRequest,
  CreateMeetingAttemptRequestV2,
  MapString,
  MeetingAttemptReservationResultMeetingReservation,
  MeetingAttemptResponseV2,
  MeetingAttemptV2,
  ReserveMeetingAttemptRequestV2,
  UsersAvailable,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V2<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "user-availability";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Check if the users are available for a meeting at a given start time using request body
   *
   * @tags Availability
   * @name CheckUsersAvailabilityV2
   * @request POST:/v2/tenant/{tenantId}/users/availability
   * @secure
   */
  checkUsersAvailabilityV2 = (
    tenantId: string,
    data: CheckUsersAvailabilityRequest,
    query?: {
      /** @default [] */
      feature?: AvailabilityFeature[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      UsersAvailable,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/users/availability`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for checkUsersAvailabilityV2 */
  checkUsersAvailabilityV2PathGetter = (
    tenantId: string,
    query?: {
      /** @default [] */
      feature?: AvailabilityFeature[];
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/users/availability`, query);

  /**
   * No description
   *
   * @tags Meeting Attempt
   * @name GetMeetingAttemptV2
   * @request GET:/v2/public/tenant/{tenantId}/meeting-attempt/{meetingAttemptId}
   * @deprecated
   */
  getMeetingAttemptV2 = (tenantId: string, meetingAttemptId: string, params: RequestParams = {}) =>
    this.request<
      MeetingAttemptResponseV2,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/public/tenant/${tenantId}/meeting-attempt/${meetingAttemptId}`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getMeetingAttemptV2 */
  getMeetingAttemptV2PathGetter = (tenantId: string, meetingAttemptId: string) =>
    this.getServicePath(`/v2/public/tenant/${tenantId}/meeting-attempt/${meetingAttemptId}`);

  /**
   * No description
   *
   * @tags Meeting Attempt
   * @name CreateMeetingAttemptV2
   * @request POST:/v2/tenant/{tenantId}/meeting-attempt
   * @deprecated
   * @secure
   */
  createMeetingAttemptV2 = (tenantId: string, data: CreateMeetingAttemptRequestV2, params: RequestParams = {}) =>
    this.request<
      MeetingAttemptV2,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/meeting-attempt`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createMeetingAttemptV2 */
  createMeetingAttemptV2PathGetter = (tenantId: string) =>
    this.getServicePath(`/v2/tenant/${tenantId}/meeting-attempt`);

  /**
   * No description
   *
   * @tags Meeting Attempt
   * @name ClaimAMeetingAttemptReservation
   * @request POST:/v2/public/tenant/{tenantId}/meeting-attempt/{meetingAttemptId}/reservation
   */
  claimAMeetingAttemptReservation = (
    tenantId: string,
    meetingAttemptId: string,
    data: ReserveMeetingAttemptRequestV2,
    params: RequestParams = {},
  ) =>
    this.request<
      MeetingAttemptReservationResultMeetingReservation,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/public/tenant/${tenantId}/meeting-attempt/${meetingAttemptId}/reservation`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for claimAMeetingAttemptReservation */
  claimAMeetingAttemptReservationPathGetter = (tenantId: string, meetingAttemptId: string) =>
    this.getServicePath(`/v2/public/tenant/${tenantId}/meeting-attempt/${meetingAttemptId}/reservation`);
}
